export const iconFontAwesomeAccessibilityCircleInfo = (
	<i className="fa-solid fa-circle-info"></i>
);
